<div class="tj-modal-header">
	<h4 class="tj-modal-header-title" i18n>{{ 'warning' | translate }}</h4>
</div>
<div class="tj-modal-body">
	<p>{{ 'leavePage' | translate }}</p>
</div>
<div class="tj-modal-footer">
	<button type="button" class="tj-btn tj-btn__danger" (click)="leave()">{{ 'leave' | translate }}</button>
	<button type="button" class="tj-btn tj-btn__primary" (click)="stay()" ngbAutoFocus>{{ 'stay' | translate }}</button>
</div>